module.exports = __webpack_public_path__ + "img/remo-logo.d42cb413.png";